import React from "react";
import FileSaver from "file-saver";
import Messages from "core/constants/messages";
import { Feature, isEnabled } from "core/features";
import { logApiError } from "core/lib";
import { dateWrapper } from "core/lib/date.wrapper";
import { ItemType } from "core/stores/statements-and-invoices.store";
import StatementsAndInvoicesStoreManager from "core/stores/statements-and-invoices.store.manager";
import { ModalAlert } from "components/common-ui";
import SquareLoader from "components/square-loader";
import { getItemTypes } from "../shared";

const typeOfItem = (item: any) => {
    try {
        return item.documentType.toLowerCase().includes("invoice")
            ? ItemType.invoice
            : ItemType.statement;
    } catch (error) {
        console.error(error, item);
        return "";
    }
}

const itemDate = (item: any) => dateWrapper(item.documentDate).fullMonthAndYear;

type ItemRowsProps = {
    isLoading: boolean,
    errorMessage?: string,
    type: ItemType,
    currentItems: Array<any>,
    dataManager: StatementsAndInvoicesStoreManager
}

const ItemRows = (props: ItemRowsProps) => {
    const { isLoading, errorMessage, type, currentItems, dataManager } = props;

    let existingDialog: any = null;

    if (isLoading) {
        return <SquareLoader />;
    }

    if (currentItems.length === 0) {
        const pluralTypes = getItemTypes(type);
        const message = errorMessage || `There are no ${pluralTypes} for this date range`;
        return (<p className="no-items">{message}</p>);
    }

    const download = (item: any) => {
        const documentId = item.documentId;
        const itemType = typeOfItem(item);

        if (itemType === ItemType.statement
            && !isEnabled(Feature.dashboard_statements_download)) {
            ModalAlert.error(Messages.statementsUnavailable);
            return;
        }

        const options = {
            showClose: false,
            buttonText: "Close"
        };
        existingDialog = ModalAlert.alert("Download", `Your ${type.toLowerCase()} will download shortly`, options);

        const triggerDownload = (response: any) => {
            if (response.status !== 200) {
                return;
            }

            const blob = new Blob([response.data], { type: response.headers["content-type"] });

            FileSaver.saveAs(blob, `${documentId}.pdf`);
        }

        const handleError = (error: any) => {
            const message = `Error downloading ${type}`;

            logApiError(error);

            if (existingDialog) {
                ModalAlert.close(existingDialog);
            }

            ModalAlert.error(message);
        }

        dataManager.download(type, documentId)
            .then(triggerDownload)
            .catch(handleError);
    }

    const mappingFunc = (x: any) => {
        return (
            <tr key={x.documentId} onClick={() => download(x)}>
                <td className="date">{itemDate(x)}</td>
                <td className="type">{typeOfItem(x).toString()}</td>
                <td className="download"><i className="icon-downloads" title="download"></i></td>
            </tr>
        );
    }

    return (
        <div className="statements-container">
            <table className="statements">
                <tbody>
                    {currentItems.map((x: any) => mappingFunc(x))}
                </tbody>
            </table>
        </div>
    );
}


export default ItemRows;
